module.exports = __webpack_public_path__ + "static/media/sarthika_kashmire.e082bd97.png";